import { render, staticRenderFns } from "./EducationalGroupStudentFreeze.vue?vue&type=template&id=e45c7e38&"
import script from "./EducationalGroupStudentFreeze.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudentFreeze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports